import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { getCountries } from "../servics/commercial/commercial-catalog-service";
import { setCurrencyReferential } from "../store/reducers/countrySlice";

/**
 * Charge le référentiel pays → devise du backend commercial (source de vérité) dans le slice
 * country. En cas d'échec, la table locale reste utilisée : aucune devise n'est inventée.
 */
const useCurrencyReferential = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        let cancelled = false;
        getCountries()
            .then(countries => {
                if (!cancelled) dispatch(setCurrencyReferential(countries));
            })
            .catch(() => {
                // Référentiel indisponible : repli sur src/config/countries.js.
            });
        return () => {
            cancelled = true;
        };
    }, [dispatch]);
};

export default useCurrencyReferential;
